<template>
<!--  v-if="Object.keys(doorphone).length != 0"-->
  <div>
    <v-progress-linear v-if="!loading" indeterminate color="primary"></v-progress-linear>
    <l-map
      ref="map"
      class="map"
      :center="[geoLat, geoLon]"
      :options="{ zoomControl: false, attributionControl: false }"
      :zoom="zoom"
      @click="onMapClick"
    >
      <div style="padding-bottom: 20px">
        <l-control-zoom
          position="topleft"
          zoom-in-text="<i style='color: black;'>+</i>"
          zoom-out-text="<i style='color: black;'>-</i>"
        >
        </l-control-zoom>
      </div>
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <vue2-leaflet-marker-cluster
        :options="optionsMarkerCluster"
        @clusterclick="onClusterClick"
      >
        <div v-if="isDoorphones && isThereAttachedDoorphones && !isBarrierView">
          <div v-for="(item, index) in resDoorphones" :key="index">
            <l-marker :lat-lng="[item.geo_lat, item.geo_lon]" :draggable="false">
              <marker-cluster-map
                :item="item"
                :lastUserMarker="lastUserMarker">
              </marker-cluster-map>
            </l-marker>
          </div>
        </div>
      </vue2-leaflet-marker-cluster>
      <div v-if="((!isDoorphones && !isThereAttachedDoorphones) || isBarrierView) && loading">
        <div class="btn-add-marker mr-3" v-if="showIntercomInfo && isRoleNameAdmin">
          <v-btn
            @click="startAddingMarker"
            class="text-none mb-2"
            color="medium-emphasis"
            rounded
            :disabled="isAddMarker"
          >
            Изменить координаты
          </v-btn>
          <v-btn @click="cancelMarker" class="text-none mb-2" color="medium-emphasis" rounded v-if="isAddMarker">
            Отменить изменения
          </v-btn>
          <v-btn @click="saveMarker" class="text-none" color="primary" rounded v-if="isAddMarker">
            Сохранить
          </v-btn>
        </div>
        <div v-for="(item, index) in (isBarrierView ? (doorphone.barriers || []) : doorphone.doorphones)" :key="index">
          <l-marker :lat-lng="[item.geo_lat, item.geo_lon]" :draggable="false" @dragend="onMarkerDragEnd(item)">
            <marker-cluster-map
              :item="item"
              :lastUserMarker="lastUserMarker">
            </marker-cluster-map>
          </l-marker>
        </div>
      </div>
        <l-polygon
          v-if="resComplexPolygons.coordinates && resComplexPolygons.coordinates.length"
          :lat-lngs="resComplexPolygons.coordinates"
          :options="polygonOptions"
          class="custom-polygon"
        >
          <l-tooltip>Жилой комплекс: {{ resComplexPolygons.name }}</l-tooltip>
        </l-polygon>
      <div>
        <v-snackbar
          v-model="snackbar"
          bottom
          color="info"
          timeout="4000"
        >
          {{ snackbarText }}
        </v-snackbar>
      </div>
    </l-map>
  </div>
</template>

<script>
import { LMap, LMarker, LControlZoom, LTileLayer, LPolygon, LTooltip } from 'vue2-leaflet';
import markerClusterMap from '../../components/complexesMap/MarkerClusterMap';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import { mapActions, mapGetters } from 'vuex';
import { divIcon } from 'leaflet';

export default {
  name: 'ResidentialComplexesIndividual',
  props: ['id', 'resComById'],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LTooltip,
    Vue2LeafletMarkerCluster,
    markerClusterMap,
    LControlZoom,
  },
  data () {
    return {
      resDoorphones: {},
      polygonOptions: {
        color: '#fa6674',
        fillColor: '#262121',
        fillOpacity: 0.1,
      },
      resComplexPolygons: {},
      attachedDoorphones: [],
      selectedDoorphone: {},
      snackbar: false,
      isRoleNameAdmin: false,
      snackbarText: '',
      searchValue: '',
      isAddingMarker: false,
      isAddMarker: false,
      showIntercomInfo: true,
      geoLat: '',
      geoLon: '',
      dialog: false,
      loading: false,
      isThereAttachedDoorphones: false,
      isDoorphones: false,
      filterAddress: '',
      zoom: 13,
      center: [54.318607, 48.397819],
      lastUserMarker: {},
      optionsMarkerCluster: {
        showCoverageOnHover: false,
        removeOutsideVisibleBounds: true,
        singleMarkerMode: false,
        zoomToBoundsOnClick: false,
        maxClusterRadius: 50,
        spiderLegPolylineOptions: {
          color: 'transparent',
        },
        iconCreateFunction: this.customIconCreateFunction,
      },
    };
  },
  async created () {
    if (this.$route.name === 'TheMapIndividualBarrier') {
      await this.getBarrierById(this.id);
    } else if (this.resComById === 'none') {
      await this.getDoorphoneById(this.id);
    } else {
      await this.getResidentialComplex(this.id)
        .then((data) => {
          this.resComplexPolygons = data;
          this.attachedDoorphones = this.resComplexPolygons.doorphones.map(doorphone => doorphone.id);
          if (this.attachedDoorphones[0]) {
            this.getDoorphonesByIds(this.attachedDoorphones);
          } else {
            const originCoordinatesResComplex = this.resComplexPolygons.coordinates[0];
            this.isThereAttachedDoorphones = true;
            this.geoLat = originCoordinatesResComplex[0];
            this.geoLon = originCoordinatesResComplex[1];
          }
        });
    }
    switch (this.roleName) {
      case 'admin' : this.isRoleNameAdmin = true;
        break;
    }
    window.addEventListener('resize', this.checkScreenWidth);
    this.checkScreenWidth();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
  methods: {
    ...mapActions({
      getDoorphone: 'Doorphone/getDoorphone',
      getMapDoorphones: 'Doorphone/getMapDoorphones',
      getResidentialComplex: 'ResidentComplex/viewComplex',
      updateCoordsDoorphone: 'Doorphone/updateCoordsDoorphone',
      updateCoordsBarrier: 'Barriers/updateCoordsBarrier',
    }),
    checkScreenWidth () {
      const screenWidth = window.innerWidth;
      this.showIntercomInfo = screenWidth >= 800;
    },
    searchAddressDoorphone (addressDoorphone) {
      this.searchValue = addressDoorphone;
    },
    onMapClick (event) {
      if (this.isAddingMarker) {
        const { lat, lng } = event.latlng;
        const collection = this.isBarrierView ? this.doorphone.barriers : this.doorphone.doorphones;
        const selected = this.selectedDoorphone;
        const isOnMap = collection.find(item => item.id === selected.id);
        if (isOnMap) {
          this.removedMarker = selected;
          this.$store.commit('removeMarker', selected);
        }
        if (this.lastUserMarker) {
          this.$store.commit('removeMarker', this.lastUserMarker);
        }
        const newMarker = {
          id: selected.id,
          address: selected.address,
          snapshot: selected.snapshot,
          type: this.isBarrierView ? 'B' : 'M',
          geo_lat: lat,
          geo_lon: lng,
        };
        this.lastUserMarker = newMarker;
        this.$store.commit('addDoorphone', newMarker);
      }
    },
    startAddingMarker () {
      this.isAddMarker = true;
      this.snackbarText = 'Передвигайте метку на карте';
      this.snackbar = true;
      setTimeout(() => {
        this.isAddingMarker = true;
        this.selectedDoorphone = this.isBarrierView
          ? (this.doorphone.barriers && this.doorphone.barriers[0])
          : this.doorphone.doorphones[0];
      }, 300);
    },
    async cancelMarker () {
      this.isAddingMarker = false;
      this.isAddMarker = false;
      if (this.lastUserMarker) {
        this.$store.commit('removeMarker', this.lastUserMarker);
      }
      if (this.removedMarker) {
        this.$store.commit('addDoorphone', this.removedMarker);
      }
      this.removedMarker = null;
      this.snackbar = false;
      this.lastUserMarker = {};
      this.$flash_danger('Изменения отменились');
    },
    async saveMarker () {
      this.isAddingMarker = false;
      this.isAddMarker = false;
      this.snackbar = false;
      const coords = {
        geo_lat: this.lastUserMarker.geo_lat,
        geo_lon: this.lastUserMarker.geo_lon,
      };
      if (this.isBarrierView) {
        await this.updateCoordsBarrier({
          id: this.selectedDoorphone.id,
          barrier: coords,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
            setTimeout(() => this.$nextTick(() => this.returnBarrier()), 1500);
          })
          .catch((message) => {
            this.cancelMarker();
            if (message && message.length > 0) {
              for (let i = 0; i < message.length; i++) {
                this.$flash_warning(message[i]);
                console.error(message);
                this.$sentry_exception && this.$sentry_exception(message);
              }
            } else {
              this.$flash_warning('Ошибка при изменении информации');
            }
          });
      } else {
        await this.updateCoordsDoorphone({
          id: this.selectedDoorphone.id,
          doorphone: coords,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
            setTimeout(() => this.$nextTick(() => this.returnDoorphone()), 1500);
          })
          .catch((message) => {
            this.cancelMarker();
            if (message.length > 0) {
              for (let i = 0; i < message.length; i++) {
                this.$flash_warning(message[i]);
                console.error(message);
                this.$sentry_exception(message);
              }
            } else {
              this.$flash_warning('Ошибка при изменении информации');
            }
          });
      }
    },
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    returnBarrier () {
      this.$router.push({ name: 'DetailBarrier', params: { id: this.$route.params.id } });
    },
    onMarkerDragEnd (marker) {
      this.$flash_success('Метка перемещена');
      this.lastUserMarker = marker;
    },
    async getDoorphoneById (id) {
      await this.getMapDoorphones({
        filters: { doorphone_id: id },
      })
        .then((res) => {
          this.loading = true;
          this.geoLat = res.data.doorphones[0].geo_lat;
          this.geoLon = res.data.doorphones[0].geo_lon;
        })
        .catch(() => {
          this.$flash_warning('Произошла ошибка загрузке карты');
          setTimeout(() => this.$nextTick(() => {
            this.returnDoorphone();
          }), 1500);
        });
    },
    onClusterClick (a) {
      if (this.$refs.map && this.$refs.map.mapObject) {
        this.$refs.map.mapObject.fitBounds(a.layer.getBounds().pad(0.5));
      }
    },
    customIconCreateFunction (cluster) {
      const childCount = cluster._childCount;
      const firingCount = cluster._firingCount;

      let className = 'custom-cluster-icon';
      if (childCount < 10) {
        className += ' custom-cluster-icon-small';
      } else if (childCount < 100) {
        className += ' custom-cluster-icon-medium';
      } else {
        className += ' custom-cluster-icon-large';
      }
      if (firingCount && firingCount === 0) {
        className += ' custom-cluster-icon-none';
      }
      return divIcon({
        html: `<div class='${className}'><span>${childCount}</span></div>`,
        className,
      });
    },
    async getBarrierById (id) {
      await this.getMapDoorphones({
        filters: { barrier_id: [id] },
      })
        .then((res) => {
          const data = res.data?.data || res.data;
          const barriers = (data && data.barriers) ? data.barriers : [];
          if (barriers.length) {
            this.isDoorphones = true;
            this.isThereAttachedDoorphones = true;
            this.resDoorphones = barriers;
            this.geoLat = barriers[0].geo_lat;
            this.geoLon = barriers[0].geo_lon;
            this.loading = true;
          } else {
            this.$flash_warning('Шлагбаум не найден на карте или координаты не заданы');
            this.loading = true;
          }
        })
        .catch(() => {
          this.$flash_warning('Произошла ошибка загрузки карты');
          setTimeout(() => this.$nextTick(() => {
            this.$router.push({ name: 'Barriers' });
          }), 1500);
        });
    },
    async getDoorphonesByIds (id) {
      await this.getMapDoorphones({
        filters: { doorphone_id: id },
      })
        .then((res) => {
          this.isDoorphones = true;
          this.isThereAttachedDoorphones = true;
          this.resDoorphones = res.data.doorphones;
          this.geoLat = this.resDoorphones[0].geo_lat;
          this.geoLon = this.resDoorphones[0].geo_lon;
        })
        .catch(() => {
          this.$flash_warning('Произошла ошибка загрузке карты');
          setTimeout(() => this.$nextTick(() => {
            this.$router.push({ name: 'Doorphone' });
          }), 1500);
        });
    },
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/mapDoorphones',
      roleName: 'roleName',
    }),
    isBarrierView () {
      return this.$route.name === 'TheMapIndividualBarrier';
    },
  },
};
</script>

<style lang="scss">
@import '../../components/complexesMap/TheMap.scss';
.map {
  width: -webkit-fill-available;
  position: fixed;
  height: 100%;
}
.base-popup {
  width: 300px;
}
.btn-add-marker {
  position: absolute;
  display: grid;
  top: 10px;
  right: 17%;
  z-index: 9999;
}
.btn-add-polygon {
  position: absolute;
  display: grid;
  top: 10px;
  right: 34%;
  //z-index: 9999;
}
.v-card__text, .v-card__title {
  word-break: normal;
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
@media screen and (max-width: 1550px) {
  .btn-add-marker {
    top: 140px;
    right: 3%;
    z-index: 0;
  }
  .btn-add-polygon {
    top: 185px;
    right: 3%;
    z-index: 0;
  }
  .btn-add-polygon-mobile-active {
    top: 140px;
    right: 5%;
  }
}

@media screen and (max-width: 400px) {
  .btn-add-polygon {
    right: 11%;
  }
}
</style>
